import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import StyledFlash from './flash.style';
import useInterval from '../../../../../hooks/useInterval';

import { getRandomNumber } from '../../../../../helper';

const Flash = ({ delay = 1, onAnimationEnd = () => {} }) => {
  useInterval(onAnimationEnd, 20000);

  const first = useMemo(() => getRandomNumber(-50, 50), []);
  const second = useMemo(() => getRandomNumber(-50, 50), []);

  const firstWidth = useMemo(() => getRandomNumber(200, 400), []);
  const secondWidth = useMemo(() => getRandomNumber(200, 400), []);

  return (
    <StyledFlash $delay={delay} $first={first} $second={second}>
      <div style={{ width: firstWidth }} />
      <div style={{ width: secondWidth }} />
    </StyledFlash>
  );
};

Flash.propTypes = {
  delay: PropTypes.number,
  onAnimationEnd: PropTypes.func
};

export default Flash;
